const DEVICE_MAP = {
  h5: {
    width: 375,
    height: 812,
  },
  table: {
    width: 768,
    height: 1024,
  },
  web: {
    width: 1440,
    height: 1024,
  },
  web_4k: {
    width: 2560,
    height: 1920,
  },
};

const DEVICE_TYPE_LIST = [
  {
    label: '自定义',
    value: 'custom',
  },
  {
    label: '通用',
    value: 'normal',
    icon: 'ios-desktop-outline',
  },
  {
    label: 'H5 (375x812)',
    value: 'h5',
    icon: 'ios-phone-portrait',
  },
  {
    label: 'Table (768x1024)',
    value: 'table',
    icon: 'ios-tablet-portrait',
  },
  {
    label: 'Web (1440x1024)',
    value: 'web',
    icon: 'ios-desktop-outline',
  },
  {
    label: '4K (2560x1920)',
    value: 'web_4k',
    icon: 'ios-desktop-outline',
  },
];
const MEDIA_TYPE_LIST = [
  {
    label: '基于宽度适配',
    value: 'width',
  },
  // { TODO 后期支持高度的媒体查询
  //   label: '基于高度适配',
  //   value: 'height',
  // },
];

module.exports = { DEVICE_MAP, DEVICE_TYPE_LIST, MEDIA_TYPE_LIST };
